/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
// These colours are used BOTH as a fill behind white text and as the text colour of
// flat/line buttons and chips, so each needs 4.5:1 in either direction (WCAG SC 1.4.3).
// The originals failed: success #28C76F was 2.21:1 and warning #FF9F43 was 2.04:1 on
// white. me2 measured the flat buttons on the #F6F6F6 card background (audit 18.1), so the
// ratios below are against #F6F6F6 - the harder case; against white they are ~0.35 higher.
export const colors = {
  primary: '#3f7d5f', // 4.51:1 on #F6F6F6 - unchanged, already passing
  success: '#167C43', // was #28C76F (2.21:1) -> 4.7:1
  danger: '#DC1718', // was #EA5455 (3.56:1) -> 4.6:1
  warning: '#B05400', // was #FF9F43 (2.04:1) -> 4.7:1
  dark: '#1E1E1E', // 16.67:1 - unchanged
};

// CONFIGS
const themeConfig = {
  disableCustomizer: true, // options[Boolean] : true, false(default)
  disableThemeTour: true, // options[Boolean] : true, false(default)
  footerType: 'static', // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: false, // options[Boolean] : true, false(default)
  mainLayoutType: 'vertical', // options[String]  : vertical(default) / horizontal
  navbarColor: '#fff', // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: 'floating', // options[String]  : floating(default) / static / sticky / hidden
  routerTransition: 'zoom-fade', // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl: false, // options[Boolean] : true, false(default)
  sidebarCollapsed: false, // options[Boolean] : true, false(default)
  theme: 'light', // options[String]  : "light"(default), "dark", "semi-dark"

  // Not required yet - WIP
  userInfoLocalStorageKey: 'userInfo',

  contentWidth: 9,
  sidebarWidth: 3,
  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
};

import Vue from 'vue';
import Vuesax from 'vuesax';

Vue.use(Vuesax, { theme: { colors }, rtl: themeConfig.rtl });

export default themeConfig;
